import { Icon, Tag } from 'ui';
import type { ChangeRequestStatus } from 'models/service';

type P = {
  startTime: Date;
  status?: ChangeRequestStatus;
};

const EventChangeRequestStatusTag = ({ status }: P) => {
  if (status === 'pending') {
    return (
      <Tag color="warning" icon={<Icon icon="time-fill" />}>
        Pending
      </Tag>
    );
  }

  if (status === 'denied') {
    return (
      <Tag color="error" icon={<Icon icon="close-circle-fill" />}>
        Declined by admin
      </Tag>
    );
  }

  if (status === 'expired') {
    return <Tag icon={<Icon icon="calendar-time-add-fill" />}>Past due</Tag>;
  }

  return <Tag icon={<Icon icon="document-3-fill" />}>Not published</Tag>;
};

export default EventChangeRequestStatusTag;
